import { postData, getData, patchData, deleteData } from 'src/utils/axios';
import { urlMap } from 'src/utils/urls';

export const getTelecarePackages = async (clinicId) =>
  getData(`${urlMap.telepackages.all}?clinic_id=${encodeURIComponent(String(clinicId))}`);

export const addTelecarePackage = async (packageData) =>
  postData(urlMap.telepackages.create, packageData);

export const deleteTelecarePackage = async (packageId, clinicId) =>
  deleteData(
    `${urlMap.telepackages.delete.replace(':telepackagesId', packageId)}?clinic_id=${encodeURIComponent(String(clinicId))}`
  );

export const getTelecarePackage = async (packageId, clinicId) =>
  getData(
    `${urlMap.telepackages.byId.replace(':telepackagesId', packageId)}?clinic_id=${encodeURIComponent(String(clinicId))}`
  );

export const updateTelecarePackage = async (packageId, packageData, clinicId) =>
  patchData(
    `${urlMap.telepackages.update.replace(':telepackagesId', packageId)}?clinic_id=${encodeURIComponent(String(clinicId))}`,
    packageData
  );

export const toggleTelecarePackage = async (packageId, data, clinicId) =>
  patchData(
    `${urlMap.telepackages.update.replace(':telepackagesId', packageId)}?clinic_id=${encodeURIComponent(String(clinicId))}`,
    data
  );

export const getUserTelePackageResponses = async (page, limit) =>
  getData(
    `${urlMap.telepackages.responses}?page=${encodeURIComponent(
      page
    )}&limit=${encodeURIComponent(limit)}`
  );
export const getUserTelePackageResponse = async (userResponseId) =>
  getData(urlMap.telepackages.edit_responses.replace(':userResponseId', userResponseId));

export const updateUserTelePackageResponse = async (userResponseId, data) =>
  patchData(
    urlMap.telepackages.update_responses.replace(':userResponseId', userResponseId),
    data
  );

